import { render, staticRenderFns } from "./overviewList.vue?vue&type=template&id=34977b84&scoped=true&"
import script from "./overviewList.vue?vue&type=script&lang=js&"
export * from "./overviewList.vue?vue&type=script&lang=js&"
import style0 from "./overviewList.vue?vue&type=style&index=0&id=34977b84&prod&lang=scss&"
import style1 from "./overviewList.vue?vue&type=style&index=1&id=34977b84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34977b84",
  null
  
)

export default component.exports